import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { SparklesIcon } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-20 pb-16 md:pt-32 md:pb-24 px-4 overflow-hidden bg-rose-50/50" data-id="element-37">
      {/* Background decorative elements */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full max-w-7xl overflow-hidden -z-10 pointer-events-none" data-id="element-38">
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-rose-200/40 rounded-full blur-3xl" data-id="element-39" />
        <div className="absolute top-32 -left-24 w-72 h-72 bg-pink-200/40 rounded-full blur-3xl" data-id="element-40" />
      </div>

      <div className="max-w-4xl mx-auto text-center" data-id="element-41">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-42">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-rose-100 text-rose-700 font-semibold text-sm mb-8" data-id="element-43">
            <SparklesIcon className="w-4 h-4" data-id="element-44" />
            <span data-id="element-45">For Aspiring Nail Techs in the USA</span>
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-slate-900 tracking-tight mb-6 leading-tight" data-id="element-46">
            How to Generate Your First{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-rose-500 to-pink-600" data-id="element-47">
              $5,000 Monthly
            </span>{' '}
            as an Independent Nail Tech in the USA in the Next 30 Days...
          </h1>

          <p className="text-xl md:text-2xl text-slate-700 font-medium mb-8 max-w-3xl mx-auto leading-relaxed" data-id="element-48">
            Without expensive cosmetology school, without spending thousands on
            products, and even if you've never held a brush in your life.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-white p-6 md:p-8 rounded-2xl shadow-xl border border-rose-100 mb-10 max-w-3xl mx-auto" data-id="element-49">
          <p className="text-lg md:text-xl text-slate-600 leading-relaxed" data-id="element-50">
            <strong className="text-slate-900" data-id="element-51">
              Stop trading your time for a $15/hour minimum wage.
            </strong>{' '}
            Learn the exact system to master professional techniques and attract
            premium clients in your city who pay $100+ per set (plus incredible
            tips).
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} data-id="element-52">
          <CTAButton size="xl" className="w-full sm:w-auto" scrollTo="price-offer-cta" data-id="element-53">
            YES, I WANT MY FREEDOM
          </CTAButton>
          <p className="mt-4 text-sm text-slate-500 font-medium" data-id="element-54">
            Secure checkout • Instant lifetime access
          </p>
        </motion.div>
      </div>
    </section>;
}